export default __webpack_public_path__ + "static/media/item-premium@2x.a9c6c440.png";